import { Button, TextInput, Toggle } from "@/ui";
import React from "react";
import AuthPage from "@/app/(auth)/components/AuthPage";
import { getTenantInfo } from "@/lib/theme/tenant";
import FormikInput from "@/ui/forms/FormikInput";
import { Field, Form, Formik, useFormik, useFormikContext } from "formik";
import { RegisterPayload, validateRegisterForm } from "@/app/(auth)/data";

const initialValues = { email: "", password: "", confirmPassword: "" };

export default function RegisterForm({ onSubmit }) {
    const tenantInfo = getTenantInfo();

    return (
        <Formik<RegisterPayload>
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={validateRegisterForm}>
            {(form) => (
                <AuthPage strapline={`Welcome to your ${tenantInfo.appName}`}>
                    <h2 className="text-xl font-semibold font-poppins">
                        Welcome to Bippit!
                    </h2>
                    <p className="text-base font-lato mt-1">
                        Enter your work email and set a password to claim your
                        account
                    </p>

                    <Form>
                        <div className="space-y-8 my-8">
                            <FormikInput
                                id="email"
                                name="email"
                                type="email"
                                label="Email Address"
                            />
                            <FormikInput
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                                autoComplete="new-password"
                                description="Password field must contain 8 characters, 1 number and a uppercase character"
                            />

                            <FormikInput
                                id="confirm-password"
                                name="confirmPassword"
                                label="Confirm Password"
                                type="password"
                                description="Passwords must match"
                            />
                        </div>
                        <div className="space-y-4">
                            <Button
                                id="auth-button"
                                fill
                                onClick={form.submitForm}
                                disabled={form.isSubmitting}>
                                Claim account
                            </Button>
                        </div>
                    </Form>
                </AuthPage>
            )}
        </Formik>
    );
}
